var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3866 8.11337L10.6933 4.34671C10.4666 4.02671 10.0999 3.83337 9.70661 3.83337C8.71328 3.83337 8.13994 4.95337 8.71328 5.76004L10.6666 8.50004L8.71328 11.24C8.13328 12.0467 8.71328 13.1667 9.70661 13.1667C10.0999 13.1667 10.4733 12.9734 10.6999 12.6534L13.3933 8.88671C13.5533 8.65337 13.5533 8.34671 13.3866 8.11337Z",
    fill: "#4A4A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72011 8.11337L6.03344 4.34671C5.80011 4.02671 5.43344 3.83337 5.04011 3.83337C4.04677 3.83337 3.46677 4.95337 4.04677 5.76004L6.00011 8.50004L4.04677 11.24C3.46677 12.0467 4.04677 13.1667 5.04011 13.1667C5.43344 13.1667 5.80677 12.9734 6.03344 12.6534L8.72677 8.88671C8.88677 8.65337 8.88677 8.34671 8.72011 8.11337Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.2ef4ead8.svg";
export { ForwardRef as ReactComponent };